/**
 * @module messenger/widget/messages
 */
const ngComponentName = 'onswMessengerMessageBox';
export default ngComponentName;
export const messagesComponent: angular.IComponentOptions = {
  bindings: {
    amateur: '<',
    voicemessageInfo: '<',
  },
  templateUrl: '/template/messenger.messages', // TODO template override exists!
  controller: ['$scope', '$element', '$timeout', 'messenger', 'sock', '$compile', 'Widget', '$attrs', controller],
};

import angular from 'angular';
import {Message} from '../model/message';
import {WidgetConstructor} from 'acng/core/factory/widget';
import {Amateur} from 'acng/amateurPool/factory/Amateur';
import {on, off} from '@acng/frontend-bounty';

type Scope = angular.IScope & {
  dialog?: import('../factory/dialog').Dialog;
  messages?: Message[];
  displayAttachment(evt: Event, url: string): void;
  voicemessageInfo?: boolean;
};

function controller(
  this: angular.IController & {amateur: Amateur; voicemessageInfo: boolean},
  scope: Scope, //
  element: JQLite,
  $timeout: angular.ITimeoutService,
  messenger: import('../factory/messenger').IMessenger,
  sock: core.Sock,
  $compile: angular.ICompileService,
  Widget: WidgetConstructor,
  $attrs: angular.IAttributes
) {
  const widget = new Widget(scope, element);

  const scrollBox = angular.isDefined($attrs.disableScroll) ? null : element.closest('.ons-scroll').children('.box');
  const dialogBox = element.parents('.messenger-dialog');

  function blubb() {
    dialogBox.removeClass('short');
    scrollBox!.off('scroll', blubb);
  }

  scope.$watch(sock.online, connected => element.toggleClass('offline', !connected));
  scope.$watch('messages.length', () => $timeout(() => scrollBox?.animate({scrollTop: scrollBox[0].scrollHeight}), 100));

  const clear = () => {
    delete scope.messages;
  };

  const listener = (evt: Event) => {
    DEBUG: console.debug('onswMessengerMessageBox', {evt});
    if (!scope.messages) {
      return;
    }
    const msg = (evt as CustomEvent).detail.message as Message;
    if (msg.sender == this.amateur.id) {
      msg.translate().then(() => {
        scope.messages!.push(msg);
        scope.dialog!.read();
      });
    }
    if (msg.recipient == this.amateur.id) {
      msg.ready = true;
      scope.messages.push(msg);
    }
  };

  const update = () => {
    delete scope.messages;
    if (scope.dialog) {
      off(scope.dialog, 'message', listener);
    }
    element.removeClass('ready');
    if (!this.amateur) {
      return;
    }
    scrollBox?.on('scroll', blubb);
    dialogBox.addClass('short');
    const dialog = messenger.get(this.amateur.id, true);
    scope.dialog = dialog;
    scope.voicemessageInfo = this.voicemessageInfo;
    widget
      .clear()
      .busy(scope.dialog.getMessages())
      .then(messages => {
        for (const message of messages) {
          message.translate();
        }
        scope.messages = messages;
        dialog.read();
        on(dialog, 'message', listener);
        $timeout(() => element.addClass('ready'), 100); // timeout currently prevents animation TODO
      });
  };

  on(sock, 'open', update);
  on(sock, 'close', clear);

  this.$onChanges = update;
  this.$onDestroy = () => {
    scrollBox?.off('scroll', blubb);
    off(sock, 'close', clear);
    off(sock, 'open', update);
  };

  scope.displayAttachment = ($event, url) => {
    if (url.match(/\.jpe?g$/i)) {
      $compile('<image-overlay src="' + url + '"></image-overlay>')(scope).appendTo(angular.element('body'));
      $event.preventDefault();
    }
  };
}
